// removed by extract-text-webpack-plugin
module.exports = {"root":"_2ynoY","spinnerWrap":"zJTUm"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/containers/PayButton/PayButton.scss
// module id = 218
// module chunks = 0 1